import { render, staticRenderFns } from "./clientOverview_listItemActivity.vue?vue&type=template&id=6016ec7b&scoped=true&"
import script from "./clientOverview_listItemActivity.vue?vue&type=script&lang=js&"
export * from "./clientOverview_listItemActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016ec7b",
  null
  
)

export default component.exports